<template>
    <div id="phone-ui" v-if="showPhoneUI">
        <div ref="audioContainer"></div>
        <div :class="callBoxClass">
            <PhoneStatus />
            <PhoneButtons />
        </div>
    </div>
</template>

<script>
import webRTC from '@/components/Dispatching/VoIP/TravellerWebRTC';
import phone from '@/store/dispatching/phone';
import realtime from '@/store/realtime/realtime';

import PhoneStatus from '@/components/Dispatching/VoIP/PhoneStatus.vue';
import PhoneButtons from '@/components/Dispatching/VoIP/PhoneButtons.vue';

export default {
    name: 'PhoneUI',
    components: { PhoneStatus, PhoneButtons },
    data: function() {
        return {
            phonebookUpdater: null
        };
    },
    beforeCreate: function() {
        if (!this.$store.state.phone) {
            this.$store.registerModule('phone', phone);
        }
        if (!this.$store.state.realtime) {
            this.$store.registerModule('realtime', realtime);
        }
    },
    mounted() {
        this.initialize();
    },
    beforeUnmount() {
        this.uninitialize();
    },
    computed: {
        sipClientId() {
            return this.$store.state.userPreferences.userParameters.SIP_CLIENT_ID;
        },
        action() {
            return this.$store.state.phone.phoneState.action;
        },
        callBoxClass() {
            let classs = 'call-box';
            if (this.$store.state.phone.phoneState.status == 'call_connected') {
                classs += ' active';
            }
            return classs;
        },
        showPhoneUI() {
            return this.$UIPrivilege('dispatching', 'voip_phone') && this.sipClientId;
        }
    },
    watch: {
        action(a) {
            switch (a) {
                case 'start_call':
                    // Set the phone state so that incoming calls from Asterisk will be answered automatically.
                    webRTC.acceptCall();
                    this.$store.dispatch(this.$store.state.phone.phoneState.isGroupCall ? 'phone/makeGroupCall' : 'phone/makeIndividualCall').then(() => {
                        // Success
                    }, () => {
                        // Call failed at request to vTraveller.
                        webRTC.rejectCall();
                    });
                    break;
                case 'end_call':
                    webRTC.endCall();
                    break;
                case 'mute':
                    webRTC.mute();
                    break;
                case 'unmute':
                    webRTC.unmute();
            }
        }
    },
    methods: {
        initialize() {
            if (this.sipClientId) {
                this.$store.dispatch('phone/subscribeToEvents', this.sipClientId);
                this.$store.dispatch('phone/getPhonebook').then(() => {
                    this.$store.dispatch('realtime/getVehicles').then(() => {
                        this.$store.commit('phone/createReversePhonebook', this.$store.state.realtime.vehicles.list);
                    });
                });
                this.phonebookUpdater = setTimeout(this.updatePhonebook, 10000);

                let that = this;
                let callbacks = {
                    connected: () => { that.$store.commit('phone/connected'); },
                    disconnected: () => { that.$store.commit('phone/disconnected'); },
                    registered: () => { that.$store.commit('phone/registered'); },
                    unregistered: () => { that.$store.commit('phone/unregistered'); },
                    //callConnected: () => { that.$store.commit('phone/callConnected'); }, // No event will notify when the other participant has actually answered the call.
                    callEnded: () => { that.$store.commit('phone/callEnded'); },
                    callError: () => { that.$store.commit('phone/callError'); },
                    muted: () => { that.$store.commit('phone/muted'); },
                    unmuted: () => { that.$store.commit('phone/unmuted'); },
                    newMessage: (data) => { that.onSIPMessage(data); }
                };
                // Configuration from the server is required before initializing the WebRTC client.
                this.$store.dispatch('phone/getSipConfiguration', this.sipClientId).then(() => {
                    webRTC.initialize(this.$store.state.phone.sipConfiguration, this.$refs.audioContainer, callbacks);
                    webRTC.start();
                }, () => {
                    setTimeout(this.initialize, 30000);
                });
            } else {
                // Status message for when there is no SIP client ID, and hence no configuration.
                this.$store.commit('phone/unconfigured');
            }
        },
        uninitialize() {
            clearTimeout(this.phonebookUpdater);
            
            if (this.sipClientId) {
                this.$store.dispatch('phone/unsubscribeFromEvents', this.sipClientId);
            }
        },
        onSIPMessage(data) {
            if (data.originator == 'remote') {
                // Received a SIP message.
                let message = JSON.parse(data.request.body);
                if (message.type.toLowerCase() == 'endpoint_state_change' ) {
                    if( message.data.state.toLowerCase() == 'up' &&
                        this.$store.state.phone.phoneState.status == 'calling') {
                        // indexOf will catch both cases, if sipClientId is a member of the array "recipient" or if the string recipient contains sipClientId.
                        if (this.$store.state.phone.phoneState.recipient.indexOf(message.data.sipClientId) > -1) {
                            this.$store.commit('phone/callConnected');
                        }
                    }
                    this.$store.dispatch( {
                        type:'phone/channelStateChange' , state: message.data.state?.toLowerCase(), sipClientId: message.data.sipClientId
                    })
                }
                
                //TODO Other SIP messages/types, e.g. channel_state_change to channel "down".
            }
        },
        updatePhonebook() {
            clearTimeout(this.phonebookUpdater);
            this.$store.dispatch('phone/getPhonebook').then(() => {
                this.$store.commit('phone/createReversePhonebook', this.$store.state.realtime.vehicles.list);
            });
            this.phonebookUpdater = setTimeout(this.updatePhonebook, 10000);
        }
    }
}
</script>